import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-customer-success-stories',
  templateUrl: './customer-success-stories.component.html',
})
export class CustomerSuccessStoriesComponent {
  general: boolean = false;
  specific: boolean = false;
  source = "";
  loading: boolean = false;
  blogs = [];

  constructor(public router: Router, private httpService: HttpService, private activeRoute: ActivatedRoute) {
  
    this.source = decodeURI(this.activeRoute.snapshot.params['id']);

    console.log(this.source)

    if (this.source == "undefined") {

      this.general = true;
      this.fetchBlogs();

    }
    else {

      this.specific = true
      this.fetchOneBlog();

    }


  }




  fetchBlogs() {

    this.loading = true;




    this.httpService.post<any>('Store/fetch-cabbagepay-stories', false).subscribe(
      resp => {
        this.blogs = JSON.parse(resp.message);

        console.log(this.blogs);


        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }


  blog;

  fetchOneBlog() {

    this.loading = true;


    const request = {
      route: this.source
    }

    this.httpService.post<any>('Store/fetch-specific-cabbagepay-story', request, false).subscribe(
      resp => {
        this.blog = JSON.parse(resp.message);

        console.log(this.blog);


        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }








}
